export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Fiber optic technicians and splicers, telecom field technicians, FTTH and structured cabling installers, network and transmission engineers, radio, microwave and tower technicians, NOC and maintenance staff, and advanced telecommunications engineering students.',
  ],
  ['Content depth?', 'From fundamentals to professional-level installation, testing, operations and maintenance.'],
  [
    'Is it vendor-specific?',
    'No. It is vendor-neutral and based on internationally used concepts and terminology.',
  ],
  [
    'Format?',
    'Professional PDF technical reference files with instant access. It is not software, a simulator, a design tool, editable spreadsheets or a course with a certificate.',
  ],
  [
    'Does it replace site procedures?',
    'No. It does not replace network operator procedures, manufacturer documentation, site safety rules or the judgement of qualified, authorised personnel. Never look into an active fiber or connector.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
